import { useEffect, useState } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";

const AddToPantryModal = ({ isOpen, onClose, onBarcodeScanned }) => {
    const [barcode, setBarcode] = useState("");
    const [scanner, setScanner] = useState(null);

    useEffect(() => {
        if (!isOpen) return; // Prevent reloading scanner when modal is closed

        const scannerInstance = new Html5QrcodeScanner(
            "barcode-reader",
            { fps: 10, qrbox: { width: 250, height: 250 } },
            false
        );

        scannerInstance.render(
            (decodedText) => {
                setBarcode(decodedText);
                onBarcodeScanned(decodedText); // Pass barcode to parent component
                scannerInstance.clear(); // Stop scanning after successful scan
            },
            (errorMessage) => {
                console.log("Scan Error:", errorMessage);
            }
        );

        setScanner(scannerInstance);

        return () => {
            scannerInstance.clear();
        };
    }, [isOpen, onBarcodeScanned]);

    return isOpen ? (
        <div className="modal-overlay">
            <div className="modal">
                <h2>Add to Pantry</h2>
                
                {/* Barcode Input Field */}
                <input
                    type="text"
                    value={barcode}
                    readOnly
                    placeholder="Scanned Barcode"
                    className="barcode-input"
                />

                {/* Barcode Scanner */}
                <div id="barcode-reader"></div>

                {/* Modal Buttons */}
                <div className="modal-buttons">
                    <button onClick={onClose} className="close-button">
                        Close
                    </button>
                </div>
            </div>
        </div>
    ) : null;
};

export default AddToPantryModal;
